import { createContext } from "react";

const PageContext = createContext(null);

export default PageContext;